import { apiClient } from '../../../app/api/apiClient';
import type { SettingsOverview } from '../types/settings.types';

export async function getSettingsOverview(): Promise<SettingsOverview> {
  const response = await apiClient.get('/api/super-admin/settings/overview');
  return (response.data as { settings: SettingsOverview }).settings;
}
